import { observer } from "mobx-react"
import { useStore } from "@features/common"
import { ARTICLE_PREVIEW_CLIPPATH_ID } from "@features/journal"
import PureSvg from "@assets/media/journal/pure-logo-landing.svg"
import ButtonSvg from "@assets/media/journal/banner-button.svg"

export const PromoBanner = observer(function PromoBanner() {
  const {
    BlogModel: { promoBanner },
  } = useStore()

  if (!promoBanner) {
    return null
  }

  return (
    <section
      className="container py-3.5 tablet-s:px-6"
      data-test-id="promo_banner"
    >
      <div
        className="bg-gray-400 flex flex-col items-center overflow-hidden border-none relative pt-6 tablet:pt-8 laptop:pt-0 laptop:pb-0 laptop:flex-row laptop:justify-center"
        style={{
          clipPath: `url(#${ARTICLE_PREVIEW_CLIPPATH_ID})`,
        }}
      >
        <PureSvg className="w-4/5 h-auto tablet:w-auto tablet:h-[172px] laptop:h-[134px] desktop:h-[179px]" />
        <div className="text-white text-center py-8 px-11 tablet:px-8.5 tablet:py-12 laptop:max-w-sm laptop:text-left laptop:p-0 laptop:ml-12 laptop:pt-10 laptop:pb-19 desktop:pt-15 desktop:pb-20">
          <div className="font-serif text-2xl tracking-2 uppercase tablet:text-2xl">
            {promoBanner.title}
          </div>
          <hr className="my-4 border-t-3 border-t-gold-300 w-20 mx-auto laptop:mx-0" />
          <div className="font-sans text-sm tablet:text-xl mb-8">
            {promoBanner.description}
          </div>
          <a
            className="relative h-[70px] flex justify-center mx-auto cursor-pointer tablet:w-[325px] laptop:mx-0 group"
            href={promoBanner.buttonLink}
            data-test-id="promo_banner__button"
          >
            <ButtonSvg className="absolute text-white group-hover:text-gold-300 transition-colors tablet:w-[325px] laptop:left-0" />
            <span className="font-sans-bold text-sm uppercase text-black z-1 mt-[23px] laptop:text-xl">
              {promoBanner.buttonText}
            </span>
          </a>
        </div>
      </div>
    </section>
  )
})
